import { lazyLoad } from "utils";

export const BusinessesSavingsPageLazy = lazyLoad(
  () => import("./index"),
  (module) => module.BusinessesSavingsPage
);

export const BusinessesVaultSavingsDetailsPageLazy = lazyLoad(
  () => import("../../features/businesses-savings/vault-savings-details"),
  (module) => module.VaultSavingsDetailsPage
);

export const BusinessesFixedDepositsDetailsPageLazy = lazyLoad(
  () => import("../../features/businesses-savings/fixed-deposits-details"),
  (module) => module.FixedDepositsDetailsPage
);

export const BusinessesVaultSavingsHistoryPageLazy = lazyLoad(
  () => import("./VaultSavingsHistoryPage"),
  (module) => module.VaultSavingsHistoryPage
);

export const BusinessesFixedDepositsHistoryPageLazy = lazyLoad(
  () =>
    import("../../features/businesses-savings/fixed-deposits-savings-history"),
  (module) => module.FixedDepositsSavingsHistoryPage
);
